import { sdkRequest } from '@eb/http';

export const LOGIN_URL = '/api/v3/auth/login/';
export const LOGIN_WITH_TOKEN_URL = '/auth/provision_from_token/';
/**
 *API to Login User
 */
export const logInUser = ({ data }) => {
    const fetchOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },

        body: JSON.stringify(data),
    };
    return sdkRequest(LOGIN_URL, fetchOptions)
        .then((response) => response)
        .catch((error) => {
            throw error.parsedError;
        });
};

/**
 * Given an external provider and a token.
 * If email and the social identity exists, the user is logged in
 * If email exists and doesn't have social identity, it is linked and logged in
 * If none of them exists, create user and social identity, and the user is logged in
 */

export const loginWithToken = ({ externalProvider, externalToken }) =>
    sdkRequest(LOGIN_WITH_TOKEN_URL, {
        method: 'POST',
        body: JSON.stringify({
            external_token: externalToken,
            external_provider: externalProvider,
        }),
    })
        .then((response) => response)
        .catch((response) => {
            throw response.parsedError;
        });
